var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { buildCountryData, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from "react-international-phone";
import { useTranslation } from "react-i18next";
import { InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { usePortal } from "../../../../../Providers/PortalProvider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
const modifiedCountries = defaultCountries.map((country) => {
    const parsedCountry = parseCountry(country);
    if (parsedCountry.iso2 == "fi") {
        // One provider in finland have 10 digits?
        parsedCountry.format = {
            default: ".. ... .. ..",
            "/^457/": "... ... .. ..",
        };
    }
    return buildCountryData(parsedCountry);
});
const phoneNumberSx = {
    "& .MuiOutlinedInput-input": {
        pl: "80px",
    },
    "&.three-digits-country-code .MuiOutlinedInput-input": {
        pl: "90px",
    },
    "& .MuiOutlinedInput-adornedStart": {
        pl: 0,
    },
};
const countrySelectSx = {
    minWidth: "28px",
    "& .MuiSelect-select": {
        pr: "18px",
        pl: 0,
    },
    "& .MuiSelect-icon": {
        right: 0,
    },
};
const countryPrefixSx = {
    fontSize: "14px",
    ml: "4px",
    fontWeight: "bold",
};
const startAdornmentSx = {
    position: "absolute",
    left: "8px",
    p: 0,
};
const InputMobileNumber = (_a) => {
    var _b, _c;
    var { field, form } = _a, restProps = __rest(_a, ["field", "form"]);
    const portal = usePortal();
    const [t] = useTranslation();
    const allowedCountries = useMemo(() => {
        const lowerCaseAllowedSMSCountryCodes = portal.options.allowedSMSCountryCodes.map((countryCode) => countryCode.toLowerCase());
        console.log("Lower case countries", lowerCaseAllowedSMSCountryCodes);
        return modifiedCountries.filter((dc) => lowerCaseAllowedSMSCountryCodes.indexOf(dc[1]) >= 0);
    }, [portal.options.allowedSMSCountryCodes]);
    const inputMobileValue = ((_b = field.value) !== null && _b !== void 0 ? _b : "").replace(/^[0\s]+/, "");
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
        defaultCountry: portal.locale.country.twoLetterCode.toLowerCase(),
        countries: modifiedCountries,
        // Trim existing zeros in case the number is "filled"
        value: inputMobileValue,
        onChange: (data) => {
            console.log("Data input value is ", data.inputValue);
            // If no input, make sure the field is empty
            if (!data.inputValue) {
                form.setFieldValue(field.name, "");
                return;
            }
            console.log("The input value", data);
            // Trim spaces and remove leading zeros
            // FIXME: May not always work if the number start with (+)country code
            const trimmedPhone = data.inputValue.trim().replace(/^[0\s]+/, "");
            const newNumber = "+" + data.country.dialCode + trimmedPhone;
            console.log("Set trimmed number", data, trimmedPhone, newNumber);
            form.setFieldValue(field.name, newNumber);
        },
        disableDialCodeAndPrefix: true,
    });
    const cleanupNumber = (number) => {
        return number.replace(/ /g, "").replace(/^0+/, "");
    };
    console.log("The country", country);
    // React int.mobile don't handle autofill/paste any good, try to fix it
    const handleNumberChange = (e) => {
        console.log("Preprocess number", e.target.value);
        let inputValue = e.target.value;
        // A lot of the problems is removed by removing leading zeros
        inputValue = cleanupNumber(inputValue);
        // We may also have leading zeros after the country prefix?
        console.log("Preprocess input value", inputValue);
        if (inputValue[0] === "+") {
            // Assume we have a valid country
            for (const allowedCountry of allowedCountries) {
                const countryCode = allowedCountry[2];
                if (inputValue.startsWith("+" + countryCode)) {
                    let mobileWithoutCountryCode = inputValue.substring(countryCode.length + 1);
                    mobileWithoutCountryCode = cleanupNumber(mobileWithoutCountryCode);
                    inputValue = "+" + countryCode + mobileWithoutCountryCode;
                    console.log("Found country for mobile", countryCode, inputValue, mobileWithoutCountryCode);
                }
                //const country = getCountry(allowedCountry);
                console.log("Allowed country", allowedCountry);
            }
        }
        e.target.value = inputValue;
        handlePhoneValueChange(e);
    };
    const fieldError = form.errors[field.name];
    const helperText = form.touched[field.name] && typeof fieldError === "string"
        ? fieldError
        : "";
    console.log("Number field", field, form);
    return (React.createElement(TextField, Object.assign({ variant: "outlined", color: "primary", onChange: handleNumberChange, onBlur: field.onBlur, type: "tel", value: inputValue, name: field.name, inputRef: inputRef, sx: phoneNumberSx, className: country.dialCode.length === 3
            ? "three-digits-country-code"
            : "two-digits-country-code", error: form.touched[field.name] && !!form.errors[field.name], helperText: helperText, InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: "start", sx: startAdornmentSx },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                    React.createElement(Select, { id: "input-mobile", value: country.iso2, onChange: (e) => setCountry(e.target.value), variant: "standard", disableUnderline: true, displayEmpty: true, IconComponent: ArrowDropDownIcon, sx: Object.assign(Object.assign({}, countrySelectSx), { width: 40, minWidth: 40, display: "flex", alignItems: "center", "& .MuiSelect-select": {
                                display: "flex",
                                alignItems: "center",
                                p: 0,
                            } }), inputProps: { "aria-label": (_c = t("Choose country")) !== null && _c !== void 0 ? _c : "" }, renderValue: (value) => (React.createElement(FlagImage, { iso2: value, style: { display: "block", width: 24 } })), MenuProps: {
                            sx: {
                                height: 300,
                                width: 360,
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                        } }, allowedCountries.map((c) => {
                        const country = parseCountry(c);
                        return (React.createElement(MenuItem, { key: country.iso2, value: country.iso2 },
                            React.createElement(FlagImage, { iso2: country.iso2, style: { marginRight: 8, width: 24 } }),
                            React.createElement(Typography, { sx: { mr: 2 } }, country.name),
                            React.createElement(Typography, { variant: "subtitle2" },
                                "+",
                                country.dialCode)));
                    })),
                    React.createElement(Box, { sx: countryPrefixSx },
                        "+",
                        country.dialCode)))),
        } }, restProps)));
};
export default InputMobileNumber;
